
import { Component, Vue, Prop } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import homeModal from "./home-modal.vue";
import { State } from "vuex-class";
import maxNumber from "@/components/max-number/max-number.vue";
import { getHomeStatAssets } from "@/api/api-operation-service";

@Component({
  components: {
    "pi-home-modal": homeModal,
    "pi-max-number": maxNumber
  }
})
export default class PiHomeAssetInfo extends Vue {
  //资产数据
  private statAssets: objAny = {
    acPileCount: 0,
    acPower: 0,
    dcPileCount: 0,
    dcPower: 0,
    gunCount: 0,
    pileCount: 0,
    staCount: 0,
    totalPower: 0
  };

  async getHomeStatAssets(): Promise<void> {
    const ret = await getHomeStatAssets({});
    if (ret.status === this.$config.apiStatus) {
      if (ret.data.length > 0) {
        this.statAssets = ret.data[0];
      }
    }
  }
  mounted() {
    this.getHomeStatAssets();
  }
}
